import { useEffect, useState } from 'react';

export default function useLoadNextPaint() {
    const [isReadyToPaint, setIsReadyToPaint] = useState(false);

    useEffect(() => {
        setTimeout(() => setIsReadyToPaint(true), 0);
    }, []);

    return isReadyToPaint;
}
